var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadpdf({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_976_1428)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    width: 59,
    height: 59,
    rx: 29.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0379 33.6792V39.2514C44.0379 39.9903 43.7444 40.699 43.2219 41.2215C42.6994 41.744 41.9907 42.0375 41.2518 42.0375H21.749C21.0101 42.0375 20.3014 41.744 19.7789 41.2215C19.2564 40.699 18.9629 39.9903 18.9629 39.2514V33.6792",
    stroke: "#423D90",
    strokeWidth: 2.70417,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5332 26.7139L31.4985 33.6791L38.4638 26.7139",
    stroke: "#423D90",
    strokeWidth: 2.70417,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5 33.6791V16.9624",
    stroke: "#423D90",
    strokeWidth: 2.70417,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_976_1428",
    x: 0.0333334,
    y: 0,
    width: 62.9333,
    height: 62.9333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.96667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.983333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_976_1428"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_976_1428",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadpdf);
export default __webpack_public_path__ + "static/media/downloadpdf.3d4ff66497c0589434e9391a7824ddae.svg";
export { ForwardRef as ReactComponent };